import { api } from '@/services'
export function fetchQuestionnaireQuestions(questionnaireId) {
    return api.get(`/admin/question/show/${questionnaireId}`)
}
export function create(questionnaireId, params) {
    return api.post(`/admin/question/create/${questionnaireId}`, params)
}
export function fetch(questionId) {
    return api.get(`/admin/question/fetchQuestion/${questionId}`)
}
export function update(params) {
    return api.post(`/admin/question/update/${params.id}`, params)
}
export function createAlert(params) {
    return api.post('/admin/question/createAlert', params)
}
export function deleteAlerts(id) {
    return api.post(`/admin/question/deleteAlerts/${id}`)
}
export function deleteQuestion(id) {
    return api.delete(`/admin/question/${id}`)
}
